module.exports = __webpack_public_path__ + "img/201604-1-1024x1024.515f47b0.jpg";